import React from 'react'
import pic1 from '../image/pic1.jpg'
import pic2 from '../image/pic2.jpg'
import pic3 from '../image/pic3.png'
import pic4 from '../image/pic4.jpg'
import pic5 from '../image/pic5.jpg'
import pic6 from '../image/pic6.webp'


function HomePage() {
    return (
        <div>
            <div>
                <h1 id='hh'>Welcome to my Blogging Site</h1>
            </div>
            <div className="container">

                <div id="carouselExampleControls" class="carousel slide" data-bs-ride="carousel" style={{height:"400px"}}>
                    <div class="carousel-inner">
                        <div class="carousel-item active">
                            <img src={pic1} class="d-block w-100" style={{height:"380px",objectFit:"fill"}} alt="..." />
                        </div>
                        <div class="carousel-item">
                            <img src={pic2} class="d-block w-100" style={{height:"380px",objectFit:"fill"}} alt="..." />
                        </div>

                        <div class="carousel-item">
                            <img src={pic6} class="d-block w-100" style={{height:"380px",objectFit:"fill"}} alt="..." />
                        </div>

                        <div class="carousel-item">
                            <img src={pic3} class="d-block w-100" style={{height:"380px",objectFit:"fill"}} alt="..." />
                        </div>

                        <div class="carousel-item">
                            <img src={pic4} class="d-block w-100" style={{height:"380px",objectFit:"fill"}} alt="..." />
                        </div>

                        <div class="carousel-item">
                            <img src={pic5} class="d-block w-100" style={{height:"380px",objectFit:"fill"}} alt="..." />
                        </div>



                    </div>
                    <button class="carousel-control-prev" type="button" data-bs-target="#carouselExampleControls" data-bs-slide="prev">
                        <span class="carousel-control-prev-icon" aria-hidden="true"></span>
                        <span class="visually-hidden">Previous</span>
                    </button>
                    <button class="carousel-control-next" type="button" data-bs-target="#carouselExampleControls" data-bs-slide="next">
                        <span class="carousel-control-next-icon" aria-hidden="true"></span>
                        <span class="visually-hidden">Next</span>
                    </button>
                </div>

            </div>
        </div>
    )
}

export default HomePage
